import { isSubscriptionEnabled, isSubscribedTo, hasAccessToChannelByPricingPlan, isPricingPlanEnabled, } from '../../common/ui-selectors/channel/pricing';
export function canAccessChannelWithSubscription(channel) {
    return isSubscriptionEnabled(channel) && isSubscribedTo(channel);
}
export function canSubscribeToChannel(channel) {
    return isSubscriptionEnabled(channel) && !isSubscribedTo(channel);
}
export function canSubscribeToChannelByPricingPlan(channel) {
    return (isPricingPlanEnabled(channel) && !hasAccessToChannelByPricingPlan(channel));
}
export function canAccessChannelByPricingPlan(channel) {
    return (isPricingPlanEnabled(channel) && hasAccessToChannelByPricingPlan(channel));
}
//# sourceMappingURL=channel-access.js.map